// REDUX

// Tipos de acciones
export const ADD_FAVORITE = 'ADD_FAVORITE';
export const DELETE_FAVORITE = 'DELETE_FAVORITE';
export const FILTER = 'FILTER';
export const ORDER = 'ORDER';
export const CLEAR_FAVORITES =  'CLEAR_FAVORITES';
export const UPDATE_FAVORITES = "UPDATE_FAVORITES"; 